function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Utility from "../commons/Utility";
import * as JsxUtility from "../commons/JsxUtility";
import * as Api from "../ajax/SessionApi";
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';
import CustomDateComponent from "./CustomDateComponent";
import IntlMessage from '../commons/Intl';
import { Label, Errors, Placeholder, Action, CreateSession, Sessions, Session } from '../commons/IntlMessages';
import { SceneTypes } from "../enum/SceneTypes";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // 会議モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * コピー
   */

  Mode[Mode["Copy"] = 1] = "Copy";
  /**
   * コピー（新規作成）
   */

  Mode[Mode["CopyNew"] = 2] = "CopyNew";
})(Mode || (Mode = {}));
/**
 * 会議モーダルコンポーネント
 */


var SessionCopyModalComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(SessionCopyModalComponent, _React$Component);

  var _super = _createSuper(SessionCopyModalComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function SessionCopyModalComponent(props) {
    var _this;

    _classCallCheck(this, SessionCopyModalComponent);

    _this = _super.call(this, props);
    var nowStart = moment().startOf('minutes');
    var nowEnd = nowStart.clone().add('hours', 1);
    var specifyPeriod = false;
    var endDate = nowEnd;
    var endTimeHours = nowEnd.hours();
    var endTimeMinutes = nowEnd.minutes();

    if (_this.props.specifyPeriod != null) {
      // 期間指定フラグが保持されている場合
      specifyPeriod = _this.props.specifyPeriod;
    } else {
      if (_this.props.endDate != null) {
        // 終了日が保持されていた場合
        specifyPeriod = Utility.IsSpecifyPeriodMoment(_this.props.endDate);
      } else if (_this.props.endDateTime != null) {
        // その他の場合
        specifyPeriod = Utility.IsSpecifyPeriodDate(_this.props.endDateTime);
      }
    }

    if (_this.props.endDate != null) {
      endDate = _this.props.endDate;

      if (_this.props.endTimeHours != null) {
        endTimeHours = _this.props.endTimeHours;
      } else {
        endTimeHours = Number(_this.props.endDate.format("HH"));
      }

      if (_this.props.endTimeMinutes != null) {
        endTimeMinutes = _this.props.endTimeMinutes;
      } else {
        endTimeMinutes = Number(_this.props.endDate.format("mm"));
      }
    }

    var startDate = nowEnd;
    var startTimeHours = nowEnd.hours();
    var startTimeMinutes = nowEnd.minutes();

    switch (props.mode) {
      case Mode.CopyNew:
        startDate = _this.props.startDate != null ? _this.props.startDate : nowStart;
        startTimeHours = _this.props.startTimeHours != null ? _this.props.startTimeHours : nowStart.hours();
        startTimeMinutes = _this.props.startTimeMinutes != null ? _this.props.startTimeMinutes : nowStart.minutes();

        if (!specifyPeriod) {
          endDate = moment({
            year: startDate.year(),
            month: startDate.month(),
            day: startDate.date(),
            hour: startTimeHours,
            minute: startTimeMinutes
          }).clone().add('hours', 1);
          endTimeHours = endDate.hours();
          endTimeMinutes = endDate.minutes();
        }

        _this.state = {
          Modal: null,
          SessionName: _this.props.sessionName,
          StartDate: startDate,
          StartTimeHours: startTimeHours,
          StartTimeMinutes: startTimeMinutes,
          EndDate: endDate,
          EndTimeHours: endTimeHours,
          EndTimeMinutes: endTimeMinutes,
          SpecifyPeriod: specifyPeriod,
          SceneModelName: _this.props.sceneModelName,
          SceneImageName: _this.props.sceneImageName,
          Scene: null,
          TemplateNameList: [],
          TemplateId: _this.props.sessionId,
          UseState: _this.props.useState,
          UseMember: _this.props.useMember,
          Request: null,
          ErrorMessages: []
        };
        break;

      case Mode.Copy:
        startDate = _this.props.startDate != null ? _this.props.startDate : nowStart;
        startTimeHours = _this.props.startTimeHours != null ? _this.props.startTimeHours : nowStart.hours();
        startTimeMinutes = _this.props.startTimeMinutes != null ? _this.props.startTimeMinutes : nowStart.minutes();

        if (!specifyPeriod) {
          endDate = moment({
            year: startDate.year(),
            month: startDate.month(),
            day: startDate.date(),
            hour: startTimeHours,
            minute: startTimeMinutes
          }).clone().add('hours', 1);
          endTimeHours = endDate.hours();
          endTimeMinutes = endDate.minutes();
        }

        _this.state = {
          Modal: null,
          SessionName: _this.props.sessionName,
          StartDate: startDate,
          StartTimeHours: startTimeHours,
          StartTimeMinutes: startTimeMinutes,
          EndDate: endDate,
          EndTimeHours: endTimeHours,
          EndTimeMinutes: endTimeMinutes,
          SpecifyPeriod: specifyPeriod,
          SceneModelName: _this.props.sceneModelName,
          SceneImageName: _this.props.sceneImageName,
          Scene: null,
          TemplateNameList: [],
          TemplateId: _this.props.sessionId,
          UseState: _this.props.useState,
          UseMember: _this.props.useMember,
          Request: null,
          ErrorMessages: []
        };
        break;

      default:
        throw Error;
    }

    Api.GetTemplateNameList(_this.props.mode == Mode.Copy ? Utility.NullNumberToBlank(_this.props.sessionId) : "", function (data) {
      _this.setState({
        TemplateNameList: data.TemplateNameList
      });

      _this.loadScene(data.TemplateNameList);
    });
    return _this;
  }
  /**
   * シーンの読込
   */


  _createClass(SessionCopyModalComponent, [{
    key: "loadScene",
    value: function loadScene(templateNameList) {
      var _this2 = this;

      if (this.state.Request != null) {
        this.state.Request.abort();
      }

      this.setState({
        TemplateNameList: templateNameList,
        Request: null
      });
      Api.GetScene(this.props.targetFolderName, this.state.SceneImageName, function (data) {
        _this2.setState({
          TemplateNameList: templateNameList,
          Scene: data
        });

        var loading = $(".loadingImage-0");
        var scene = $(".sceneImage-0");
        var scene360 = $(".scene360-0");
        loading.removeClass("loading-hidden");
        scene.addClass("loading-hidden");
        scene360.addClass("hidden");
        var sceneImage = _this2.state.SceneImageName;

        if (loading && scene && scene360) {
          if (scene.hasClass("loading-hidden")) {
            if (sceneImage) {
              var xhr = Api.GetSceneThubnail(Utility.NullNumberToBlank(_this2.state.TemplateId), _this2.props.targetFolderName, sceneImage, 1, 0, 0, data.SceneType, function (x, y, type, file) {
                var loading = $(".loadingImage-" + x.toString());
                var capture = $(".sceneImage-" + x.toString());
                var scene360 = $(".scene360-" + x.toString());
                capture.attr('src', URL.createObjectURL(file));
                loading.addClass("loading-hidden");
                capture.removeClass("loading-hidden");

                if (type == SceneTypes._360DegreeImage) {
                  scene360.removeClass("hidden");
                }
              });

              _this2.setState({
                TemplateNameList: templateNameList,
                Scene: data,
                Request: xhr
              });
            } else {
              scene.attr('src', "/assets/img/noimage.png");
              loading.addClass("loading-hidden");
              scene.removeClass("loading-hidden");
            }
          }
        }
      });
    }
    /**
     * 会議名を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateSessionName",
    value: function updateSessionName(e) {
      this.setState({
        SessionName: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 開始日を更新します。
     *
     * @param d 開始日
     */

  }, {
    key: "updateStartDate",
    value: function updateStartDate(d) {
      var currentStartDateTime = moment(Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes));
      var currentEndDateTime = moment(Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes));
      var diff = currentEndDateTime.diff(currentStartDateTime, 'milliseconds');
      var startDateTime = moment(Utility.parseMoment(d, this.state.StartTimeHours, this.state.StartTimeMinutes));
      var endDateTime = startDateTime.clone().add('milliseconds', diff);
      this.setState({
        StartDate: d,
        EndDate: endDateTime,
        EndTimeHours: endDateTime.hours(),
        EndTimeMinutes: endDateTime.minutes()
      });
    }
    /**
     * 開始時刻（時）を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateStartTimeHours",
    value: function updateStartTimeHours(e) {
      var startHour = Number(e.target.value);
      if (startHour > 23) startHour = 0;else if (startHour < 0) startHour = 23;
      var currentStartDateTime = moment(Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes));
      var currentEndDateTime = moment(Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes));
      var diff = currentEndDateTime.diff(currentStartDateTime, 'milliseconds');
      var startDateTime = moment(Utility.parseMoment(this.state.StartDate, startHour, this.state.StartTimeMinutes));
      var endDateTime = startDateTime.clone().add('milliseconds', diff);
      this.setState({
        StartTimeHours: startHour,
        EndDate: endDateTime,
        EndTimeHours: endDateTime.hours(),
        EndTimeMinutes: endDateTime.minutes()
      });
    }
    /**
     * 開始時刻（分）を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateStartTimeMinutes",
    value: function updateStartTimeMinutes(e) {
      var startMin = Number(e.target.value);
      if (startMin > 59) startMin = 0;else if (startMin < 0) startMin = 59;
      var currentStartDateTime = moment(Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes));
      var currentEndDateTime = moment(Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes));
      var diff = currentEndDateTime.diff(currentStartDateTime, 'milliseconds');
      var startDateTime = moment(Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, startMin));
      var endDateTime = startDateTime.clone().add('milliseconds', diff);
      this.setState({
        StartTimeMinutes: startMin,
        EndDate: endDateTime,
        EndTimeHours: endDateTime.hours(),
        EndTimeMinutes: endDateTime.minutes()
      });
    }
    /**
     * 終了日を更新します。
     *
     * @param d 終了日
     */

  }, {
    key: "updateEndDate",
    value: function updateEndDate(d) {
      this.setState({
        EndDate: d
      });
    }
    /**
     * 終了時刻（時）を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateEndTimeHours",
    value: function updateEndTimeHours(e) {
      var endHour = Number(e.target.value);
      if (endHour > 23) endHour = 0;else if (endHour < 0) endHour = 23;
      this.setState({
        EndTimeHours: endHour
      });
    }
    /**
     * 終了時刻（分）を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateEndTimeMinutes",
    value: function updateEndTimeMinutes(e) {
      var endMin = Number(e.target.value);
      if (endMin > 59) endMin = 0;else if (endMin < 0) endMin = 59;
      this.setState({
        EndTimeMinutes: endMin
      });
    }
    /**
     * 期間指定を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateSpecifyPeriod",
    value: function updateSpecifyPeriod(e) {
      this.setState({
        SpecifyPeriod: e.target.checked
      });
    }
    /**
     * テンプレートを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateTemplate",
    value: function updateTemplate(e) {
      var _this3 = this;

      if (e.target.value == "") {
        this.setState({
          TemplateId: null,
          SessionName: "",
          SceneModelName: this.props.defaultSceneModelName,
          SceneImageName: this.props.defaultSceneImageName
        }, function () {
          _this3.loadScene(_this3.state.TemplateNameList);
        });
      } else {
        var session = this.state.TemplateNameList.find(function (t) {
          return t.SessionId == parseInt(e.target.value);
        });
        var sceneModelName = this.props.defaultSceneModelName;
        var sceneImageName = this.props.defaultSceneImageName;

        if (session) {
          sceneModelName = session.SceneModelName;
          sceneImageName = session.SceneImageName;
          var specifyPeriod = Utility.IsSpecifyPeriodDate(session.EndDateTime);
          this.setState({
            TemplateId: parseInt(e.target.value),
            SessionName: e.target.options[e.target.selectedIndex].label.slice(13),
            SpecifyPeriod: specifyPeriod,
            SceneModelName: sceneModelName,
            SceneImageName: sceneImageName
          }, function () {
            _this3.loadScene(_this3.state.TemplateNameList);
          });
        } else {
          this.setState({
            TemplateId: parseInt(e.target.value),
            SessionName: e.target.options[e.target.selectedIndex].label.slice(13),
            SceneModelName: sceneModelName,
            SceneImageName: sceneImageName
          }, function () {
            _this3.loadScene(_this3.state.TemplateNameList);
          });
        }
      }
    }
    /**
     * 状態利用を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUseState",
    value: function updateUseState(e) {
      this.setState({
        UseState: e.target.checked
      });
    }
    /**
     * メンバー利用を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateUseMember",
    value: function updateUseMember(e) {
      this.setState({
        UseMember: e.target.checked
      });
    }
    /**
     * 「更新」ボタン押下時の処理を行います。
     */

  }, {
    key: "onCopy",
    value: function onCopy() {
      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;
        var startDateTime = Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes);
        var endDateTime = Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes); // 過去の時刻が設定されていたら現在時刻にする

        var currentDate = moment().startOf('minutes');

        if (moment(startDateTime).diff(currentDate) <= 0) {
          startDateTime = currentDate.toDate();
        }

        if (moment(endDateTime).diff(moment(startDateTime)) <= 0) {
          this.state.ErrorMessages.push(intl.format(Errors.InputPariod));
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        if (!this.state.TemplateId) {
          throw Error();
        }

        if (!this.state.SpecifyPeriod) {
          endDateTime = Utility.MaxDateTime.toDate();
        }

        this.props.onCopy(this.state.TemplateId, this.state.SessionName, startDateTime, endDateTime, this.state.SceneModelName, this.state.SceneImageName, this.props.targetFolderName, this.state.UseState, this.state.UseMember);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * 「変更」ボタン押下時の処理を行います。
     */

  }, {
    key: "onChangeScene",
    value: function onChangeScene() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onChangeScene(this.state.TemplateId, this.state.SessionName, this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes, this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes, this.state.SpecifyPeriod, this.state.UseState, this.state.UseMember, this.state.Scene);
      this.state.Modal.modal('hide');
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      var modal = $('#SessionCopyModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function (e) {
        _this4.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionCopyModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "40",
        src: "/assets/img/Icon_Calender.svg"
      }), (this.props.mode == Mode.Copy || this.props.mode == Mode.CopyNew) && this.state.TemplateNameList && this.state.TemplateNameList.length > 0 && [/*#__PURE__*/React.createElement("h3", null, intl.format(CreateSession.Title))]), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-8 leftArea"
      }, (this.props.mode == Mode.Copy || this.props.mode == Mode.CopyNew) && [/*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "TemplateName"
      }, intl.format(Label.Template)), !(this.state.TemplateNameList && this.state.TemplateNameList.length > 0) && /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "TemplateName",
        id: "TemplateName",
        readOnly: true,
        value: intl.format(Session.SearchingHistory),
        tabIndex: 100
      })), this.props.isHistory && this.state.TemplateNameList && this.state.TemplateNameList.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "TemplateName",
        id: "TemplateName",
        readOnly: true,
        value: Utility.ToMoment(this.state.TemplateNameList[0].StartDateTime).format("YYYY/MM/DD") + "-" + this.state.TemplateNameList[0].SessionName,
        tabIndex: 100
      })), !this.props.isHistory && this.state.TemplateNameList && this.state.TemplateNameList.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "Room",
        name: "Room",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        onChange: function onChange(e) {
          return _this5.updateTemplate(e);
        },
        value: Utility.NullNumberToBlank(this.state.TemplateId),
        tabIndex: 100
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, intl.format(Sessions.TemplateOptionsNone)), this.state.TemplateNameList && this.state.TemplateNameList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("option", {
          value: x.SessionId
        }, Utility.ToMoment(x.StartDateTime).format("YYYY/MM/DD"), " - ", x.SessionName);
      })), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "Room",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "checkbox icheck-asbestos"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "useState"
      }, intl.format(Sessions.UseState)), /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "useState",
        name: "useState",
        onChange: this.updateUseState.bind(this),
        checked: this.state.UseState
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "checkbox icheck-asbestos"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "useMember"
      }, intl.format(Sessions.UseMember)), /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "useMember",
        name: "useMember",
        onChange: this.updateUseMember.bind(this),
        checked: this.state.UseMember
      }))))], /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "SessionName"
      }, intl.format(Label.Name)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "SessionName",
        id: "SessionName",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 40,
        onChange: function onChange(e) {
          return _this5.updateSessionName(e);
        },
        value: this.state.SessionName,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.Letters, {
          value: "40"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "SessionName",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "StartDate"
      }, intl.format(Label.StartDate)), /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomDateComponent, null),
        name: "StartDate",
        id: "StartDate",
        tabIndex: 103,
        selected: this.state.StartDate,
        onChange: this.updateStartDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        name: "StartTimeHours_Input",
        className: "moment-input",
        type: "number",
        value: Utility.NullNumberToBlank(this.state.StartTimeHours).padStart(2, "0"),
        onChange: this.updateStartTimeHours.bind(this)
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        "data-toggle": "dropdown",
        "aria-expanded": "false"
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "dropdown-menu moment-dropdown-menu"
      }, JsxUtility.CreateHoursListItems(this.updateStartTimeHours.bind(this)))), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        name: "StartTimeMinutes_Input",
        className: "moment-input",
        type: "number",
        value: Utility.NullNumberToBlank(this.state.StartTimeMinutes).padStart(2, "0"),
        onChange: this.updateStartTimeMinutes.bind(this)
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        "data-toggle": "dropdown",
        "aria-expanded": "false"
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "dropdown-menu moment-dropdown-menu"
      }, JsxUtility.CreateUnitsOf15MinutesListItems(this.updateStartTimeMinutes.bind(this))))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "checkbox icheck-asbestos"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "specifyPeriod"
      }, intl.format(Label.SpecifyPeriod)), /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "specifyPeriod",
        name: "specifyPeriod",
        onChange: this.updateSpecifyPeriod.bind(this),
        checked: this.state.SpecifyPeriod
      })))), this.state.SpecifyPeriod && /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "EndDate"
      }, intl.format(Label.EndDate)), /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomDateComponent, null),
        name: "EndDate",
        id: "EndDate",
        tabIndex: 104,
        selected: this.state.EndDate,
        onChange: this.updateEndDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        name: "EndTimeHours_Input",
        className: "moment-input",
        type: "number",
        value: Utility.NullNumberToBlank(this.state.EndTimeHours).padStart(2, "0"),
        onChange: this.updateEndTimeHours.bind(this)
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        "data-toggle": "dropdown",
        "aria-expanded": "false"
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "dropdown-menu moment-dropdown-menu"
      }, JsxUtility.CreateHoursListItems(this.updateEndTimeHours.bind(this)))), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, /*#__PURE__*/React.createElement("input", {
        name: "EndTimeMinutes_Input",
        className: "moment-input",
        type: "number",
        value: Utility.NullNumberToBlank(this.state.EndTimeMinutes).padStart(2, "0"),
        onChange: this.updateEndTimeMinutes.bind(this)
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        "data-toggle": "dropdown",
        "aria-expanded": "false"
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "dropdown-menu moment-dropdown-menu"
      }, JsxUtility.CreateUnitsOf15MinutesListItems(this.updateEndTimeMinutes.bind(this)))))), /*#__PURE__*/React.createElement("div", {
        className: "col-3 rightArea"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
        className: "title-label"
      }, intl.format(Label.SceneSelection))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "sceneImageFrame"
      }, /*#__PURE__*/React.createElement("img", {
        className: "sceneImage loadingImage-0 loading-spinner",
        src: "/assets/img/Loading.svg"
      }), /*#__PURE__*/React.createElement("img", {
        className: "sceneImage sceneImage-0 loading-hidden",
        src: "/assets/img/noimage.png"
      }), /*#__PURE__*/React.createElement("img", {
        className: "scene360 scene360-0 hidden",
        src: "/assets/img/Icon_360Image.svg"
      }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
        className: "display-label"
      }, this.state.Scene ? this.state.Scene.SceneDisplayName : this.state.SceneImageName)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "imgAndTextBtn",
        onClick: this.onChangeScene.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Action.Change))))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer modal-footer-container justify-content-center"
      }, (this.props.mode == Mode.Copy || this.props.mode == Mode.CopyNew) && this.state.TemplateNameList && this.state.TemplateNameList.length > 0 && [/*#__PURE__*/React.createElement("button", {
        key: "button",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onCopy.bind(this),
        tabIndex: -1
      }, intl.format(Action.Entry))]))));
    }
  }]);

  return SessionCopyModalComponent;
}(React.Component);

export { SessionCopyModalComponent as default };